var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread"},[_c('div',{staticClass:"example-container"},[_c('el-breadcrumb',{staticClass:"flex",attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.path }}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }